import Skeleton from '@/shared/Loaders/Skeleton'
import css from './skeletonMaintenanceEventList.module.css'

const SkeletonMaintenanceEventList = ({ eventNumber = 3 }) => {
  const renderSkeletonMaintenanceEventItem = (key: number) => {
    return (
      <div className={css.wrapper} key={key}>
        <Skeleton style={{ borderRadius: '4px' }} height="18px" width="90px" />
        <Skeleton style={{ borderRadius: '4px' }} height="22px" width="100%" />
        <div className="inline-flex-gap gap8 center" style={{ width: key % 2 === 0 ? 'calc(100% - 40px)' : '100%' }}>
          <Skeleton style={{ borderRadius: '4px' }} height="16px" width="120px" />
          <div className={css.divider}></div>
          <Skeleton style={{ borderRadius: '4px' }} height="16px" width={key % 2 === 0 ? '72px' : '120px'} />
        </div>
      </div>
    )
  }
  return (
    <div className="width100">
      {Array.from({ length: eventNumber }).map((_, index) => renderSkeletonMaintenanceEventItem(index))}
    </div>
  )
}

export default SkeletonMaintenanceEventList
